/*! @azure/msal-common v8.0.0 2022-11-07 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "8.0.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@azure/msal-common/dist/packageMetadata.js
// module id = 87
// module chunks = 0